import { PlayData, Podcast } from '../../types';
import AnchorAPIError from './AnchorAPIError';

// TODO: Should we make this type more robust by specifying the possible platforms?
interface PlaysByGeo {
  [app: string]: {
    percentOfPlays: number;
  };
}

const decodeResponseIntoPlaysByGeo = (json: any): PlaysByGeo => {
  const {
    data: {
      assets: { flagUrlByGeo },
    },
  } = json;
  return json.data.rows.reduce(
    (playsByGeoAccum: PlaysByGeo, row: any) => ({
      ...playsByGeoAccum,
      [row[0]]: {
        flagAssetUrl: flagUrlByGeo[row[0]],
        percentOfPlays: row[1],
      },
    }),
    {}
  );
};

type Level = 1 | 2 | 3 | 4 | 5;

interface GeoLevel {
  kind: 'geoLevel';
  level: Level;
}

interface Geo {
  kind: 'geo';
  level: Level;
  name: string;
}
interface FetchCurrentPodcastsPlaysByGeoArgs {
  geo: GeoLevel | Geo;
}

const getUrl = (
  podcast: Podcast,
  geo: GeoLevel | Geo,
  maxGeoCount: number = 200
) => {
  const { id } = podcast;
  if (id.kind !== 'webId') {
    throw new Error('only supports webId');
  }
  const baseUrlPath = `/api/proxy/v3/analytics/station/webStationId:${id.webId}/playsByGeo?`;
  const baseUrlPathWithLimit = `${baseUrlPath}${
    maxGeoCount ? `limit=${maxGeoCount}` : ''
  }`;
  switch (geo.kind) {
    case 'geo':
      return `${baseUrlPathWithLimit}&geo${geo.level}=${encodeURIComponent(
        geo.name
      )}&resultGeo=geo${geo.level + 1}`;
    case 'geoLevel':
      return `${baseUrlPathWithLimit}&resultGeo=geo${geo.level}`;
    default:
      const exhaustiveCheck: never = geo;
      return exhaustiveCheck;
  }
};
const fetchCurrentPodcastsPlaysByGeo = (
  podcast: Podcast,
  geo: GeoLevel | Geo = {
    kind: 'geoLevel',
    level: 1,
  },
  maxGeoCount: number = 200
) => {
  const { id } = podcast;
  if (id.kind !== 'webId') {
    return Promise.reject(new Error('only supports webId'));
  }
  return new Promise<PlaysByGeo>((resolve, reject) => {
    const urlPath = getUrl(podcast, geo, maxGeoCount);
    fetch(urlPath, {
      credentials: 'same-origin',
    }).then(response => {
      if (response.ok) {
        response.json().then((responseJson: any) => {
          const playsByGeo = decodeResponseIntoPlaysByGeo(responseJson);
          resolve(playsByGeo);
        });
      } else {
        const error = new AnchorAPIError(
          response,
          `Server error: ${response.statusText} (${response.status}) - ${response.url}`
        );
        reject(error);
      }
    });
  });
};

export { fetchCurrentPodcastsPlaysByGeo };
